import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '../services/user.service';
import { map } from 'rxjs';
import { AppInfo } from '../../global/environment';

export const userAuthGuard: CanActivateFn = () => {
  if (AppInfo.Environment.localDevelopment) return true;

  const authToken = inject(UserService).userToken;
  return authToken.pipe(
    map((value) => {
      return !!value;
    })
  );
};
